import { pipe } from "fp-ts/lib/pipeable";
import { underscoreCaseToNormalCase } from "../string";
import { capitalizeEveryWord } from "./capitalizeEveryWord";

export const underscoreToNormalEveryWordCapitalized = (text: string) => pipe(
    underscoreCaseToNormalCase(text),
    capitalizeEveryWord
);
